import { CommonActionType } from '../../common/common-actions';
import { CommonLabParentResourceActionType } from '../../lab-parent-resource/lab-parent-resource-actions';
export const SkuActionType = {
    ...CommonActionType,
    ...CommonLabParentResourceActionType,
    LIST_SKU_DATA: 'LIST_SKU_DATA',
    LIST_SKU_DATA_SUCCESS: 'LIST_SKU_DATA_SUCCESS',
    LIST_SKU_DATA_ERROR: 'LIST_SKU_DATA_ERROR',
};
